export type Difficulty = 'easy' | 'normal' | 'hard'

export const DIFFICULTIES: Array<{ id: Difficulty; label: string }> = [
  { id: 'easy', label: 'Easy' },
  { id: 'normal', label: 'Normal' },
  { id: 'hard', label: 'Hard' }
]

/** Tunables shared across games — higher = tougher. */
export function difficultyScale(d: Difficulty): number {
  if (d === 'easy') return 0.78
  if (d === 'hard') return 1.42
  return 1
}
